import { listenMessageFromExtension } from './listenMessageFromExtension';
import { MessageResponseTypes } from '../schema/ResponseMessageTypes';
import { composeEmail } from 'mini-mail-module-view/lib/utils/composeEmail';

export const initializeScreenShotListener = (): void => {
    listenMessageFromExtension((event: MessageEvent) => {
        const { type } = event.data;
        if (type !== MessageResponseTypes.ScreenShot) {
            return;
        }
        // Sets DeviceGUID obtained from extension as CorrelationId for all telemetry logs
        const screenshots = event.data?.data?.[0]?.image; // TODO: change this to payload convention
        composeEmail({
            newContent: `<img style="max-width: 100%;" src='data:image/png;base64,${screenshots}' alt='content grabbed with outlook widget'/>`,
        });
    });
};
